import { createAction, props } from '@ngrx/store';
import { AgendaTask, TaskCategory, TaskFile, TaskStatus } from './agenda-task.model';


// fetch 
export const fetchagendaTaskListData = createAction('[Data] fetch agendaTaskList');
export const fetchagendaTaskListSuccess = createAction('[Data] fetch agendaTaskList success', props<{ AgendaTaskListdata: AgendaTask[] }>())
export const fetchagendaTaskListFail = createAction('[Data fetch agendaTaskList failed]', props<{ error: string }>())

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records agenda task',
    props<{id: number}>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records agenda task success', 
    props<{ listData: AgendaTask[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records agenda task failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record agenda task',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record agenda task success', 
    props<{ dummyId:string, singleData: AgendaTask, files: TaskFile[], statuses: TaskStatus[], categories: TaskCategory[] }>()
);

export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record agenda task failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record agenda task',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record agenda task success'
);
export const addRecordFailure = createAction(
    '[Data] Add record agenda task failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record agenda task',
    props<{ id: string; isNew: boolean, updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record agenda task success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record agenda task failure',
    props<{ error: string }>()
);

//Update Status
export const updateRecordStatus = createAction(
    '[Data] Update record status agenda task',
    props<{ id: string; status: string }>()
);
export const updateRecordStatusSuccess = createAction(
    '[Data] Update record status agenda task success'
);
export const updateRecordStatusFailure = createAction(
    '[Data] Update record status agenda task failure',
    props<{ error: string }>()
);


// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record agenda task',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record agenda task success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record agenda task failure',
    props<{ error: string }>()
);

// Delete File
export const deleteFileRecord = createAction(
    '[Data] Delete record agenda task file',
    props<{ taskId: string, id: string }>()
);
export const deleteFileRecordSuccess = createAction(
    '[Data] Delete record agenda task file success'
);
export const deleteFileRecordFailure = createAction(
    '[Data] Delete record agenda task file failure',
    props<{ error: string }>()
);

//Change Sttaus
export const changeStatus = createAction(
    '[Data] Change task status',
    props<{ id: string }>()
);

export const changeStatusSuccess = createAction(
    '[Data] Change task status success'
);

export const changeStatusFailure = createAction(
    '[Data] Change task status failure',
    props<{ error: string }>()
);


//Fetch Open
export const fetchOpen = createAction(
    '[Data] Fetch agenda task open'
);

export const fetchOpenSuccess = createAction(
    '[Data] Fetch agenda task open success'
);

export const fetchOpenFailure = createAction(
    '[Data] Fetch agenda task open failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state agenda task',
);